module.exports = __webpack_public_path__ + "static/media/2.c4be17fe.jpg";